import {
  SET_CLIENTS,
  SET_CLIENTS_LOADING,
} from "../actions/clientActions";

const INITIAL_STATE = {
  clients: [],
  loading: false,
  latest: null,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CLIENTS:
      return {
        ...state,
        clients: action.clients,
      };

    case SET_CLIENTS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    default:
      return state;
  }
};

export default reducer;
